/**
 * Angolan kwanza.
 */
export var AOA = {
  code: 'AOA',
  base: 10,
  exponent: 2
};